import styled from 'styled-components';
import theme from '@/data/theme';

const StyledHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const StyledInquiryWrapper = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin-left: 10px;
`;

const StyledInfoIcon = styled.img`
  grid-area: 1 / 1 / 2 / 2;
`;

const StyledInquiryDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 12px;
  grid-area: 1 / 2 / 2 / 3;
  width: 100%;
`;

const StyledInquiryDetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.2rem;
  color: ${({ theme }) => theme.colors.darkSlateColor};
`;

const StyledInquiryDetailsContent = styled.a<{ $heading?: boolean }>`
  color: ${({ theme }) => theme.colors.darkSlateColor};
  font-size: ${(props) => (props.$heading ? '20px' : '14px')};
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
  text-transform: ${(props) => (props.$heading ? 'uppercase' : 'none')};
`;

const StyledInquiryDetailsContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 0.7rem;
`;
const StyledInquiryInformation = styled.a`
  color: ${theme.colors.primary};
`;

const StyledInquiryServiceIcon = styled.img``;

export {
  StyledInquiryWrapper,
  StyledInfoIcon,
  StyledInquiryDetailsWrapper,
  StyledInquiryDetails,
  StyledInquiryDetailsContent,
  StyledInquiryDetailsContentWrapper,
  StyledInquiryServiceIcon,
  StyledHeaderWrapper,
  StyledInquiryInformation,
};
